import { DealerDashboardData } from "@Hooks/useDealersDashboard";
import { formatPrice } from "@Utils/functions";
import { IoDocumentTextOutline } from "react-icons/io5";
import styles from "./Dealer.module.scss";

const DealerFinance = ({ data }: { data: DealerDashboardData | undefined }) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.sectionTitle}>
        Funded loans
        <IoDocumentTextOutline size={25} />
      </div>
      <div className={styles.sectionContent}>
        <div className={styles.sectionContentTitle}>Amount financed</div>
        <div className={styles.sectionContentValue}>
          {formatPrice(data?.data?.amountFinanced || 0)}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentTitle}>Funded loans</div>
          <div className={styles.sectionContentValue}>
            {data?.data?.totalFundedDeals || 0}
          </div>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentTitle}>
            Interest rate (average)
          </div>
          <div className={styles.sectionContentValue}>
            {data?.data?.averageInterestRate.toFixed(2) || 0}%
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentTitle}>LTV</div>
          <div className={styles.sectionContentValue}>
            {data?.data?.averageLoanToValue.toFixed(2) || 0}%
          </div>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentTitle}>Term (median)</div>
          <div className={styles.sectionContentValue}>
            {data?.data?.medianTerm || 0} months
          </div>
        </div>
      </div>
    </div>
  );
};
export default DealerFinance;
